import RelationList from './RelationList.vue'
import RelationTab from './RelationTab.vue'

export {RelationList, RelationTab}
